module.exports = __webpack_public_path__ + "static/media/Gilroy-Semibold.a550b17f.woff2";